import { toast } from "react-toastify";
import firebase from "../../config/firebase";

export const fetchBlogs =
  (lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let query = firebase
      .firestore()
      .collection("tech_Forum")
      .where("type", "==", "admin")
      .orderBy("created_at", "desc");

    if (lastDocument) {
      query = query.startAfter(lastDocument);
    }
    return query.limit(5).onSnapshot((snapshot) => {
      let temp_data = [];
      snapshot.forEach((doc) => {
        temp_data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: lastDocument ? "MORE_GET_All_BLOGS" : "GET_All_BLOGS",
        payload: {
          data: temp_data,
          lastDocument: snapshot.docs[temp_data.length - 1],
          hasMoreDocument: temp_data.length >= 5
        }
      });

      onComplete();
    });
  };

export const addBlog =
  (blog, onComplete = () => {}) =>
  async (dispatch) => {
    let { image, ...newBlog } = blog;
    try {
      const uniqueId = Date.now();
      const storageRef = firebase.storage().ref();

      const imageRef = storageRef.child(
        `athleteBlogImages/${uniqueId}_${image.name}`
      );

      imageRef
        .put(image)
        .then((snapshot) => {
          return snapshot.ref.getDownloadURL();
        })
        .then(async (url) => {
          const newData = {
            ...newBlog,
            created_at: firebase.firestore.Timestamp.now(),
            imageUrl: url
          };
          let temp = await firebase
            .firestore()
            .collection("tech_Forum")
            .add(newData);

          newData.id = temp.id;
          dispatch({ type: "AddBlog", payload: newData });
          toast.success("BLOG ADDED Successfully");
          onComplete("success");
        });
    } catch (error) {
      console.error("Error adding Blog");
      onComplete();
    }
  };

export const updateBlog =
  (blog, onComplete = () => {}) =>
  async (dispatch) => {
    let { id, image, oldImage, ...newData } = blog;
    try {
      if (image.name) {
        await firebase.storage().refFromURL(oldImage).delete();
        const storageRef = firebase.storage().ref();
        const imageRef = await storageRef.child(
          `athleteBlogImages/${image.name}`
        );
        imageRef
          .put(image)
          .then((snapshot) => {
            return snapshot.ref.getDownloadURL();
          })
          .then((url) => {
            const newUpdatedData = {
              ...newData,
              imageUrl: url
            };
            firebase
              .firestore()
              .collection("tech_Forum")
              .doc(id)
              .update(newUpdatedData)
              .then(() => {
                dispatch({
                  type: "EDIT_BLOG_DATA",
                  payload: { id, blogData: newUpdatedData }
                });
                onComplete("success");
                toast.success("BLOG updated Successfully");
              });
          });
      } else {
        const newUpdatedData = {
          ...newData,
          imageUrl: image
        };
        firebase
          .firestore()
          .collection("tech_Forum")
          .doc(id)
          .update(newUpdatedData)
          .then(() => {
            toast.success("BLOG updated Successfully");
            dispatch({
              type: "EDIT_BLOG_DATA",
              payload: { id, blogData: newUpdatedData }
            });
            onComplete("success");
          });
      }
      // await firebase.firestore().collection("tech_Forum").doc(id).update(blog);
      // toast.success("BLOG updated Successfully");
    } catch (error) {
      console.error("Error updating blog:", error);
      console.error("Error updating Blog");
      onComplete();
    }
  };

export const deleteBlog =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      if (data.imageUrl) {
        await firebase.storage().refFromURL(data.imageUrl).delete();
      }
      await firebase.firestore().collection("tech_Forum").doc(data.id).delete();
      dispatch({ type: "DELETE_BLOG", payload: data.id });
      toast.success("BLOG DELETED Successfully");
      onComplete();
    } catch (error) {
      toast.error("Error deleting BLOG");
    }
  };
